/**
 * Relais « la session d'intervention a expiré » entre l'intercepteur axios
 * (authContext) et la fiche du compte dans le back-office.
 *
 * Même mécanique que `utils/sessionExpiry` : sans lui, le retour au back-office
 * se lit comme une panne. La réponse est retenue pour la durée du chargement de
 * page, parce que React.StrictMode double l'initialiseur d'un `useState` en
 * développement et que le premier appel consommerait le drapeau (le message
 * serait apparu en production et jamais en développement).
 */
export const GOD_MODE_EXPIRED_MESSAGE = "La session d'intervention a expiré.";

const CLE = 'bsr:godmode-expiree';
let reponseDeCeChargement = null;

export function markGodModeExpired() {
  reponseDeCeChargement = null;
  try {
    sessionStorage.setItem(CLE, '1');
  } catch {
    /* on se passe du message */
  }
}

export function consumeGodModeExpired() {
  if (reponseDeCeChargement !== null) return reponseDeCeChargement;
  try {
    const pose = sessionStorage.getItem(CLE) === '1';
    if (pose) sessionStorage.removeItem(CLE);
    reponseDeCeChargement = pose;
    return pose;
  } catch {
    reponseDeCeChargement = false;
    return false;
  }
}

/** Réservé aux tests : repartir comme au chargement d'une page. */
export function __resetGodModeExpiryCache() {
  reponseDeCeChargement = null;
}
